<template>
  <div>
    <h1>Rapport complet d'avancement</h1>

    <div id="switchProjectInvoice">
      <input
        type="radio"
        class="radio-button"
        id="active"
        value="0"
        v-model="invoices"
      />
      <label for="active" class="radio-button" style="margin-right: 15px">
        Rapport par projet
      </label>
      <input
        type="radio"
        class="radio-button"
        id="all"
        value="1"
        v-model="invoices"
      />
      <label for="all" class="radio-button"> Rapport par facture </label>
    </div>

    <div class="filterForm">
      <label for="exerciceSelect" id="labelExercice">
        Exercice :
        <select
          id="exerciceSelect"
          name="exerciceSelect"
          v-model="exercice"
          title="Exercice comptable"
        >
          <option
            v-for="(e, index) in exercices"
            v-bind:key="e"
            v-bind:value="index"
          >
            {{ e }}
          </option>
        </select>
      </label>
    </div>

    <div class="load-icon" v-if="loading">
      <b-icon icon="gear-fill" animation="spin" font-scale="7"></b-icon>
    </div>
    <div class="table-advance" v-else-if="invoices == 0 && data.length > 0">
      <div id="export" class="btn btn-outline-primary" v-if="loadingExport">
        <b-icon icon="gear-fill" animation="spin" font-scale="1"></b-icon>
      </div>
      <div
        id="export"
        class="btn btn-outline-primary"
        v-on:click="exportAdvance"
        v-else
      >
        Exporter le rapport (.xlsx)
      </div>
      <div>
        <table class="table-content">
          <thead>
            <tr>
              <th
                class="header-line"
                v-for="(header, index) in headers"
                :key="index"
                v-bind:class="{
                  path_col: index == 0,
                  last_col: index == headers.length - 1,
                }"
              >
                {{ header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in data" :key="index">
              <td
                class="path_col"
                v-bind:class="{ exceed: parseInt(row['percent']) >= 100 }"
              >
                {{ row["path"] }}
              </td>
              <td
                class="other-col"
                v-bind:class="{ exceed: parseInt(row['percent']) >= 100 }"
              >
                {{ row["name"] }}
              </td>
              <td
                class="other-col"
                v-bind:class="{ exceed: parseInt(row['percent']) >= 100 }"
              >
                {{
                  isNaN(row["time"])
                    ? "/"
                    : +(Math.round(row["time"] + "e+2") + "e-2")
                }}
              </td>
              <td
                class="other-col"
                v-bind:class="{ exceed: parseInt(row['percent']) >= 100 }"
              >
                {{
                  isNaN(row["estimate"])
                    ? "/"
                    : +(Math.round(row["estimate"] + "e+2") + "e-2")
                }}
              </td>
              <td
                class="other-col last_col"
                v-bind:class="{ exceed: parseInt(row['percent']) >= 100 }"
              >
                {{ row["percent"] }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else-if="invoices == 0 && data.length == 0">
      <p class="noData">Aucunes données à afficher</p>
    </div>
    <div class="table-advance" v-else-if="dataInvoice.length > 0">
      <div id="export" class="btn btn-outline-primary" v-if="loadingExport">
        <b-icon icon="gear-fill" animation="spin" font-scale="1"></b-icon>
      </div>
      <div
        id="export"
        class="btn btn-outline-primary"
        v-on:click="exportAdvance"
        v-else
      >
        Exporter le rapport (.xlsx)
      </div>

      <div>
        <table class="table-content">
          <thead>
            <tr>
              <th
                class="header-line"
                v-for="(header, index) in headersInvoice"
                :key="index"
                v-bind:class="{
                  path_col: index == 0,
                  last_col: index == headersInvoice.length - 1,
                }"
              >
                {{ header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in dataInvoice" :key="index">
              <td
                class="path_col"
                v-bind:class="{ exceed: row['excess'] && exercice == 1 }"
              >
                {{ row["projectPath"] }}
              </td>
              <td
                class="invoice-col"
                v-bind:class="{ exceed: row['excess'] && exercice == 1 }"
              >
                {{ row["project"] }}
              </td>
              <td
                class="invoice-col"
                v-bind:class="{ exceed: row['excess'] && exercice == 1 }"
              >
                {{ row["num"] }}
              </td>
              <td
                class="invoice-col"
                v-bind:class="{ exceed: row['excess'] && exercice == 1 }"
              >
                {{ row["type"] }}
              </td>
              <td
                class="invoice-col"
                v-bind:class="{ exceed: row['excess'] && exercice == 1 }"
              >
                {{ row["start"] }}
              </td>
              <td
                class="invoice-col"
                v-bind:class="{ exceed: row['excess'] && exercice == 1 }"
              >
                {{ row["end"] }}
              </td>
              <td
                class="invoice-col last_col"
                v-bind:class="{ exceed: row['excess'] && exercice == 1 }"
              >
                {{ row["days"] }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-else>
      <p class="noData">Aucunes données à afficher</p>
    </div>
  </div>
</template>

<script>
const axios = require("axios");

export default {
  name: "AdvanceVue",
  data() {
    return {
      userId: 0,
      data: [],
      headers: [
        "Chemin dans l'arborescence",
        "Projet",
        "Temps passé (en h)",
        "Temps estimé (en h)",
        "Avancement (en %)",
      ],
      loading: true,
      loadingExport: false,
      invoices: 0,
      headersInvoice: [
        "Chemin dans l'arborescence",
        "Projet",
        "Numéro de facture",
        "Type",
        "Date de début",
        "Date de fin",
        "Nombre de jours estimés",
      ],
      dataInvoice: [],
      types: {
        REGIE: "Régie",
        FORFAIT: "Forfait",
        MAINTENANCE: "Maintenance",
      },
      exercices: [],
      exercice: 1,
    };
  },
  created: function () {
    this.userId = Number(localStorage.id);

    //Création des options de filtre d'exercice
    var actualYear = parseInt(new Date().getFullYear());
    this.exercices.push("Tous les exercices");
    this.exercices.push("Saisies ou factures récent(e)s");
    for (var i = -2; i < 3; i++) {
      this.exercices.push(actualYear + i + "-" + (actualYear + i + 1));
    }

    //Réccupération des données (avancement projet)
    this.getData();
  },
  methods: {
    getData: function () {
      // AVANCEMENT PROJET
      this.loading = true;

      //Recuperation des projet feuille de l'arborescence
      axios
        .get(this.$store.state.apiUrl + "project/getLeafs", {
          params: {
            login: localStorage.login,
            password: localStorage.pass,
          },
        })
        .then((responseProject) => {
          // Rangement des données récupérer
          var projectsIds = [];
          var projectsNames = [];
          responseProject.data.forEach((element) => {
            projectsIds.push(element.project_id);
            projectsNames.push(element.project_name);
          });

          var projectTimes = [];
          //Recuperation des saisies horaires pour les projets actuels
          axios
            .get(
              this.$store.state.apiUrl +
                "time/forProjects/" +
                projectsIds.join(),
              {
                params: {
                  login: localStorage.login,
                  password: localStorage.pass,
                },
              }
            )
            .then((responseTime) => {
              projectTimes = responseTime.data;

              var projectsEstimate = [];
              //Recuperation des temps estimés pour les projets actuels
              axios
                .get(
                  this.$store.state.apiUrl +
                    "time/getEstimateTime/" +
                    this.userId +
                    "/" +
                    1 +
                    "/" +
                    1 +
                    "/" +
                    projectsIds.join(),
                  {
                    params: {
                      login: localStorage.login,
                      password: localStorage.pass,
                    },
                  }
                )
                .then((responseEstimate) => {
                  projectsEstimate = responseEstimate.data;

                  // Erreur de réccupération //
                  if (projectsEstimate.length == 0) {
                    this.$toasted
                      .show(
                        "Erreur de connexion, Réccupération des données d'estimation impossible",
                        {
                          position: "bottom-center",
                          theme: "outline",
                        }
                      )
                      .goAway(3000);
                    this.loading = false;
                    return;
                  }

                  var projectPath = [];
                  //Recuperation des chemin d'arborescence pour les projets actuels
                  axios
                    .get(
                      this.$store.state.apiUrl +
                        "project/getPaths/" +
                        projectsIds.join(),
                      {
                        params: {
                          login: localStorage.login,
                          password: localStorage.pass,
                        },
                      }
                    )
                    .then((responsePath) => {
                      projectPath = responsePath.data;
                      this.data = [];
                      var row = {};

                      //Recuperation de l'etablissement de la récence des projets actuels
                      axios
                        .get(
                          this.$store.state.apiUrl +
                            "project/isRecent/" +
                            projectsIds.join(),
                          {
                            params: {
                              login: localStorage.login,
                              password: localStorage.pass,
                            },
                          }
                        )
                        .then((responseRecent) => {
                          var year =
                            this.exercice == 0 || this.exercice == 1
                              ? "0"
                              : this.exercices[this.exercice].split("-")[1];
                          //Verification de l'appartenance des projets actuels à l'exercice selectionné
                          axios
                            .get(
                              this.$store.state.apiUrl +
                                "project/projectInExercice/" +
                                year +
                                "/" +
                                projectsIds.join(),
                              {
                                params: {
                                  login: localStorage.login,
                                  password: localStorage.pass,
                                },
                              }
                            )
                            .then((responseExercice) => {
                              //Boucle d'ajout des informations du rapport d'avancement par projet
                              for (var i = 0; i < projectsIds.length; i++) {
                                row = {
                                  path: projectPath[i],
                                  name: projectsNames[i],
                                  time:
                                    projectTimes[i] == 0
                                      ? "/"
                                      : projectTimes[i] * 7,
                                  estimate:
                                    projectsEstimate[i] == 0
                                      ? "/"
                                      : (projectsEstimate[i] * 7).toString(),
                                  percent:
                                    projectsEstimate[i] == 0
                                      ? "/"
                                      : (
                                          Math.round(
                                            (projectTimes[i] /
                                              projectsEstimate[i]) *
                                              10000
                                          ) / 100
                                        ).toString(),
                                };

                                if (
                                  this.exercice == 0 ||
                                  (this.exercice == 1 &&
                                    responseRecent.data[i]) ||
                                  (this.exercice != 1 &&
                                    responseExercice.data[i])
                                ) {
                                  this.data.push(row);
                                  this.data.sort((a, b) =>
                                    a.path.localeCompare(b.path)
                                  );
                                }

                                //Arrêt de l'affichage du loader
                                if (i == projectsIds.length - 1)
                                  this.loading = false;
                              }
                            });
                        });
                    });
                });
            });
        });
    },
    getInvoiceData: function () {
      // AVANCEMENT FACTURE
      this.loading = true;

      //Recuperation des factures avec projet lié
      axios
        .get(this.$store.state.apiUrl + "project/getInvoiceAdvance", {
          params: {
            login: localStorage.login,
            password: localStorage.pass,
          },
        })
        .then((responseInvoice) => {
          //Initialisation des données
          var invoices = Object.values(responseInvoice.data);
          var path = "";
          var project = "";
          var row = {};
          this.dataInvoice = [];
          var year =
            this.exercice == 0
              ? "0"
              : this.exercices[this.exercice].split("-")[1];

          // Erreur de réccupération facturation //
          if (invoices.length == 0) {
            this.$toasted
              .show(
                "Erreur de connexion, Réccupération des données d'estimation impossible",
                {
                  position: "bottom-center",
                  theme: "outline",
                }
              )
              .goAway(3000);
            this.loading = false;
            return;
          }

          //Boucle de gestion des factures
          for (let i = 0; i < invoices.length; i++) {
            //Recuperation du chemin du projet associé à la facture courrante
            axios
              .get(
                this.$store.state.apiUrl +
                  "project/getPath/" +
                  invoices[i].project,
                {
                  params: {
                    login: localStorage.login,
                    password: localStorage.pass,
                  },
                }
              )
              .then((responsePath) => {
                //Recuperation du projet associé à la facture
                axios
                  .get(
                    this.$store.state.apiUrl +
                      "project/getProjectById/" +
                      invoices[i].project,
                    {
                      params: {
                        login: localStorage.login,
                        password: localStorage.pass,
                      },
                    }
                  )
                  .then((responseProject) => {
                    //Vérification de la récence du projet associé à la facture
                    axios
                      .get(
                        this.$store.state.apiUrl +
                          "project/isRecent/" +
                          invoices[i].project,
                        {
                          params: {
                            login: localStorage.login,
                            password: localStorage.pass,
                          },
                        }
                      )
                      .then((responseRecent) => {
                        //Vérification de l'appartenance à l'exercice sélectionné de la facture
                        axios
                          .get(
                            this.$store.state.apiUrl +
                              "project/invoiceInExercice/" +
                              year +
                              "/" +
                              invoices[i].number,
                            {
                              params: {
                                login: localStorage.login,
                                password: localStorage.pass,
                              },
                            }
                          )
                          .then((responseExercice) => {
                            project = responseProject.data[0].name;
                            path = responsePath.data;

                            //Etablissement du dépassement de la date de fin
                            var startDate =
                              invoices[i].start == null
                                ? null
                                : invoices[i].start.substr(0, 10).split("-");
                            var endDate =
                              invoices[i].end == null
                                ? null
                                : invoices[i].end.substr(0, 10).split("-");
                            var excess_invoice = false;
                            if (invoices[i].end != null) {
                              var date_end = new Date(
                                invoices[i].end.substr(0, 10)
                              );
                              var date_now = new Date();

                              excess_invoice = date_end < date_now;
                            }

                            //Etablissement du dépassement pour les contrats de maintenance
                            if (invoices[i].type == "MAINTENANCE") {
                              axios
                                .get(
                                  this.$store.state.apiUrl +
                                    "time/forProjects/" +
                                    invoices[i].project,
                                  {
                                    params: {
                                      login: localStorage.login,
                                      password: localStorage.pass,
                                    },
                                  }
                                )
                                .then((response) => {
                                  excess_invoice =
                                    response.data[0] > invoices[i].days;
                                });
                            }

                            //Ajout de la ligne correspondante à la facture courrante
                            row = {
                              projectPath: path,
                              project: project,
                              num: invoices[i].number,
                              type: this.types[invoices[i].type],
                              start:
                                startDate == null
                                  ? ""
                                  : startDate[2] +
                                    "/" +
                                    startDate[1] +
                                    "/" +
                                    startDate[0],
                              end:
                                endDate == null
                                  ? ""
                                  : endDate[2] +
                                    "/" +
                                    endDate[1] +
                                    "/" +
                                    endDate[0],
                              days: /*invoices[i].livr_days != 0 ? invoices[i].livr_days :*/ invoices[
                                i
                              ].days,
                              excess: excess_invoice,
                            };

                            if (
                              (this.exercice == 1 && responseRecent.data[0]) ||
                              (this.exercice != 1 && responseExercice.data)
                            ) {
                              this.dataInvoice.push(row);
                              this.dataInvoice.sort((a, b) =>
                                a.projectPath.localeCompare(b.projectPath)
                              );
                            }

                            //Arrêt de l'affichage du loader
                            if (i == invoices.length - 1) this.loading = false;
                          });
                      });
                  });
              });
          }
        });
    },
    exportAdvance: function () {
      //Event click export du tableau
      this.loadingExport = true;

      //Création des paramètres de requête d'export
      var tmpData = new FormData();
      tmpData.append(
        "headers",
        this.invoices == 1
          ? JSON.stringify(this.headersInvoice)
          : JSON.stringify(this.headers)
      );
      tmpData.append(
        "data",
        this.invoices == 1
          ? JSON.stringify(this.dataInvoice)
          : JSON.stringify(this.data)
      );

      //Requête d'export des données au format .XSLX
      axios
        .post(
          this.$store.state.apiUrl +
            "report/exportAdvanceDocument/" +
            this.invoices,
          tmpData,
          { responseType: "blob" }
        )
        .then((response) => {
          //Récupération du fichier de retour d'export
          const url = URL.createObjectURL(
            new Blob([response.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            })
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "rapportAdvance.xlsx");
          document.body.appendChild(link);
          this.loadingExport = false;
          link.click();
        });
    },
  },
  watch: {
    exercice: function () {
      if (parseInt(this.invoices)) this.getInvoiceData();
      else this.getData();
    },
    invoices: function () {
      if (parseInt(this.invoices)) this.getInvoiceData();
      else this.getData();
    },
  },
};
</script>

<style scoped>
.table-advance {
  margin: auto;
  margin-top: 2%;
  width: 98%;
}

table {
  margin: 1% auto;
}

.exceed {
  color: #dc3545;
}

.path_col {
  width: 25%;
  text-align: left;
}

.last_col {
  text-align: right;
}

.other-col {
  width: 15%;
}

.invoice-col {
  width: 10%;
}

.load-icon {
  color: #fec053;
}

#export {
  margin-bottom: 2%;
}

#labelExercice {
  margin-left: 1.5%;
}

.noData {
  color: #dc3545;
  margin-top: 5%;
  font-size: 1.2em;
}

.table-content {
  position: relative;
}

.header-line {
  position: sticky;
  top: -1px;
  background: white;
}
</style>